import Button from '@aurora/shared-client/components/common/Button/Button';
import { ButtonVariant } from '@aurora/shared-client/components/common/Button/enums';
import { dropdownPopperConfig } from '@aurora/shared-client/helpers/ui/PopperJsHelper';
import React, { useState } from 'react';
import { Dropdown, useClassNameMapper } from 'react-bootstrap';
import type { FilterMenuItem, SearchFilterDropDownProps } from '../../types';
import SearchFilterDropDownItem from '../SearchFilterDropDownItem/SearchFilterDropDownItem';
import localStyles from '../SearchWidgetFilters/SearchWidgetFilters.module.pcss';
import useTranslation from '../../../useTranslation';
import { EndUserComponent } from '@aurora/shared-types/pages/enums';

/**
 * Render the filter dropdown with the filter menu
 *
 * @author Akash Goenka
 */

const SearchFilterDropdown: React.FC<React.PropsWithChildren<SearchFilterDropDownProps>> = ({
  filterName,
  filterMenuItems,
  onChange,
  routerParam,
  activeFilterMenuItem = '',
  useCounts = false,
  contextNode,
  author,
  menuItemsToDisable
}) => {
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const { formatMessage, loading: textLoading } = useTranslation(
    EndUserComponent.SEARCH_FILTER_DROPDOWN
  );
  const cx = useClassNameMapper(localStyles);

  if (textLoading) {
    return null;
  }

  return (
    <Dropdown
      onToggle={isOpen => {
        setDropdownOpen(isOpen);
      }}
      data-menu-open={dropdownOpen}
    >
      <Dropdown.Toggle
        as={Button}
        variant={ButtonVariant.LINK}
        size="lg"
        className={cx('lia-g-dropdown-toggle')}
        data-testid={`SearchPage.Dropdown.${filterName}`}
        aria-label={formatMessage('filterBy', {
          name: formatMessage(filterName),
          itemCount: filterMenuItems.length
        })}
      >
        {formatMessage(filterName)}
      </Dropdown.Toggle>
      <Dropdown.Menu popperConfig={dropdownPopperConfig}>
        {dropdownOpen &&
          filterMenuItems.map((item: FilterMenuItem) => (
            <SearchFilterDropDownItem
              key={item}
              menuItem={item}
              activeFilterMenuItem={activeFilterMenuItem}
              onChange={onChange}
              routerParam={routerParam}
              filterName={filterName}
              useCounts={useCounts}
              contextNode={contextNode}
              author={author}
              isDisabled={menuItemsToDisable && menuItemsToDisable.includes(item)}
            />
          ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SearchFilterDropdown;
